import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useGoBack = (howFar: number = 1) => {
    const navigate = useNavigate();

    return useCallback(() => navigate(-1 * howFar), [howFar, navigate]);
};
